import { Copilot } from "./Copilot"
import { Tag } from "./Tag"

export type Package =
  { id: number
  , active: boolean
  , title: string
  , description: string
  , imageUrl?: string
  , basicAmountCents: number
  , standardAmountCents: number
  , premiumAmountCents: number
  , hourlyRateCents: number
  , canonicalPath: string
  , tags: Tag[]
  , featureRows: PackageFeatureRow[]
  , customQuestions: PackageCustomQuestion[]
  , copilotIndividual?: Copilot
  }

export enum PackageTier
  { BASIC = 'basic'
  , STANDARD = 'standard'
  , PREMIUM = 'premium'
  }

export type PackageFeatureRow =
  { id: number
  , name: string
  , description: string
  , basicValue: string
  , standardValue: string
  , premiumValue: string
  , position: number
  }

// Keep aligned with FieldType in package/custom_question.rb
export enum PackageCustomQuestionFieldType
  { SHORT_TEXT = 'short-text'
  , LONG_TEXT = 'long-text'
  , INTEGER = 'integer'
  , DROPDOWN = 'dropdown'
  , BOOLEAN = 'boolean'
  }

export type PackageCustomQuestion =
  { id: number
  , fieldType: PackageCustomQuestionFieldType
  , questionText: string
  , placeholderText: string
  , dropdownOptions: [string]
  , isRequired: boolean
  }

export type PackageCustomQuestionResponse =
  { id: number
  , question: string
  , answer: string
  }
